export const initTemplateSettings = () => {
    try {
        let txTemplateSettings = window?.lovemap?.config?.txTemplateSettings ?? {}
        txTemplateSettings = JSON.parse(txTemplateSettings)
        return {
            ...txTemplateSettings
        }
    } catch (e) {
        console.error(e)
        return {}
    }
}
let config = initTemplateSettings();

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

export default function defaultStateValue(mapData, key, defaultValue) {
    let defaultValueFromConfig = config[key] ?? defaultValue
    return isSet(mapData, key) ? mapData[key] : defaultValueFromConfig;
}